<template>
    <div class="container breakage">
        <nav class="level">
            <div class="level-left">
                <div class="level-item">
                    <b-dropdown>
                        <button class="button is-primary" slot="trigger">
                            <span>År</span><span v-if="selectedYear !== ''">: {{ selectedYear }}</span>
                            <b-icon icon="caret-down"></b-icon>
                        </button>

                        <b-dropdown-item v-for="(year, index) in years" v-bind:key="index" has-link>
                            <a @click="setSelectedYear(year)">{{ year }}</a>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                <div class="level-item">
                    <b-dropdown>
                        <button class="button is-primary" slot="trigger">
                            <span>Måned</span><span v-if="selectedMonth !== ''">: {{ selectedMonth.name }}</span>
                            <b-icon icon="caret-down"></b-icon>
                        </button>

                        <b-dropdown-item has-link>
                            <a @click="setSelectedMonth(-1)">Hele året</a>
                        </b-dropdown-item>
                        <b-dropdown-item separator></b-dropdown-item>
                        <b-dropdown-item v-for="(month, index) in months" v-bind:key="index" has-link>
                            <a @click="setSelectedMonth(month)">{{ month.name }}</a>
                        </b-dropdown-item>
                    </b-dropdown>
                </div>

                

                <!-- <div class="level-item">
                    <b-dropdown>
                        <button class="button is-primary" slot="trigger">
                            <span>Brukersted</span><span v-if="selectedMerchant !== ''">: {{ selectedMerchant }}</span>
                            <b-icon icon="caret-down"></b-icon>
                        </button>

                        <b-dropdown-item has-link>
                            <a @click="setSelectedMerchant('')">All data</a>
                        </b-dropdown-item>
                        <b-dropdown-item separator></b-dropdown-item>
                        <b-dropdown-item v-for="(merchant, index) in merchants" v-bind:key="index" has-link>
                            <a @click="setSelectedMerchant(merchant)">{{ merchant }}</a>
                        </b-dropdown-item>
                    </b-dropdown>
                </div> -->

                <div class="level-item">
                     <b-autocomplete
                        v-model="merchantSelection"
                        placeholder="Velg brukersted"
                        :open-on-focus="true"
                        :data="merchants">
                        <template slot="header">
                            <a @click="setSelectedMerchant('')">
                                <span class="has-text-weight-bold">Vis alle brukersteder</span>
                            </a> 
                        </template>
                    </b-autocomplete>
                        
                </div>

            </div>
            <div class="level-right">
                <div class="level-item">
                    <a @click="getReportFile" class="button is-info">
                            
                            <b-icon icon="save"></b-icon>
                            <span>Last ned rapport</span>

                        </a>
                </div>
                <div class="level-item" v-if="isAdmin">
                    <b-select placeholder="Velg firma" v-model="branch">
                        <option
                            v-for="option in customers"
                            :value="option.id"
                            :key="option.id">
                            {{ `${option.name} (${option.id})` }}
                        </option>
                    </b-select>
                </div>

            </div>
        </nav>
        
        <b-table 
            :data="data"
            :paginated=true
            :per-page="perPage"
            :current-page.sync="currentPage"
            :loading="loading"
            :striped="true"
            :narrowed="true"
            default-sort="breakageTime"
            default-sort-direction="desc">

            <template slot-scope="props">

                <b-table-column field="acceptorId" label="BAX nummer" sortable>
                    {{ props.row.acceptorId }}
                </b-table-column>

                <b-table-column field="merchant" label="Brukersted" sortable>
                    {{ props.row.merchant }}
                </b-table-column>

                <b-table-column field="breakageAmount" label="Beløp" sortable numeric>
                    {{ props.row.breakageAmount | currency }}
                </b-table-column>

                <b-table-column field="activateTime" label="Aktiveringsdato" sortable>
                    {{ props.row.activateTime | moment("D. MMM YYYY") }}
                </b-table-column>

                <b-table-column field="deactivateTime" label="Deaktiveringsdato" sortable>
                    {{ props.row.deactivateTime | moment("D. MMM YYYY") }}
                </b-table-column>

                <b-table-column field="breakageTime" label="Breakagedato" sortable>
                    {{ props.row.breakageTime | moment("D. MMM YYYY") }}
                </b-table-column>

            </template>

            <template slot="empty">
                <section class="section">
                    <div class="content has-text-grey has-text-centered">
                        <p>
                            <b-icon
                                pack="fa"
                                icon="recycle"
                                size="is-large">
                            </b-icon>
                        </p>
                        <p>Ingen data for valgt rapport</p>
                    </div>
                </section>
            </template>

            <template slot="footer">
                <th>
                    <div class="th-wrap">Sum totalt</div>
                </th>
                <th>
                    <div class="th-wrap"></div>
                </th>
                <th>
                    <div class="th-wrap is-numeric">{{ sum | currency }}</div>
                </th>
                <th>
                    <div class="th-wrap"></div>
                </th>
                <th>
                    <div class="th-wrap"></div>
                </th>
                <th>
                    <div class="th-wrap"></div>
                </th>
            </template>

        </b-table>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    data () {
        return {
            perPage: 100,
            currentPage: 1,
            name: ''
        }
    },
    methods: {
        ...mapActions('breakage', ['getReportData', 'setSelectedMerchant', 'getReportFile', 'setSelectedYear', 'setSelectedMonth', 'setSelectedMonthDefault']),
        ...mapActions('customers', ['getCustomers'])
    },
    computed: {
       ...mapGetters('breakage', ['data', 'loading', 'merchants', 'sum', 'selectedMerchant', 'years', 'months', 'selectedYear', 'selectedMonth']),
       ...mapGetters('customers', ['customers']),
       ...mapGetters('auth', ['isAdmin']),
       branch: {
            get() {
                return this.$store.state.breakage.branch
            },
            set (value) {
                this.$store.dispatch('breakage/setBranch', value)
            }
        },
        merchantSelection: {
            get () {
                return this.$store.state.breakage.selectedMerchant
            },
            set (value) {
                this.$store.dispatch('breakage/setSelectedMerchant', value)
            }
        }
    },
    created () {
       this.setSelectedMonthDefault()
       this.getReportData()
       this.getCustomers()
    }
    
}
</script>

<style lang="scss" scoped>
div.breakage {
    margin-top:32px;
}
</style>

